module.exports = __webpack_public_path__ + "static/media/ninx2.eee610c5.jpg";